<template>
  <div>
    <span @click="search()">
      <Button
        type="primary"
        v-hasPermission="[
          'permissionsConfigurationManagement:menuManagement:create'
        ]"
        @click="menuManagementModal = true"
        >{{ $t("MenuManagement.addMenu") }}</Button
      >
    </span>
    <Modal
      v-model="menuManagementModal"
      :title="$t('MenuManagement.addMenu')"
      :loading="loading"
      @on-ok="menuManagementSubmit('menuManagementForm')"
      @on-cancel="menuManagementReset('menuManagementForm')"
      :mask-closable="false"
    >
      <Form
        ref="menuManagementForm"
        :model="menuManagementForm"
        :label-width="100"
        :rules="ruleValidate"
      >
        <!-- 菜单角色 -->
        <FormItem :label="$t('MenuManagement.menuRole')" prop="menuRole">
          <RadioGroup v-model="menuManagementForm.menuRole">
            <Radio
              v-for="list in menuRoleList"
              :label="list.label"
              :key="list.id"
              >{{ list.name }}</Radio
            >
          </RadioGroup>
        </FormItem>
        <!-- 公司 -->
        <FormItem :label="$t('permission_configuration_management.account.company')" prop="companyIds">
          <Select
            v-model="menuManagementForm.companyIds"
            filterable
            multiple
            :placeholder="$t('alarms.common.pleaseSelectCompany')"
            :transfer="true"
            @on-change="changeCompany()"
            style="width:200px"
          >
            <Option
              :value="item.id"
              v-for="(item, index) in companyList"
              :key="index"
              :disabled="item.disabled"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>
        <!-- 类型 -->
        <FormItem :label="$t('MenuManagement.category')" prop="menuType">
          <RadioGroup
            v-model="menuManagementForm.menuType"
            @on-change="changeMenuType(menuManagementForm.menuType)"
          >
            <Radio
              v-for="list in menuTypeList"
              :label="list.label"
              :key="list.name"
              >{{ list.name }}</Radio
            >
          </RadioGroup>
        </FormItem>
        <!-- 上级菜单 -->
        <FormItem :label="$t('MenuManagement.upperMenu')">
          <Tree
            :data="menuData"
            :render="renderContent"
            @on-select-change="selectAll"
            ref="tree"
            style="height:180px;overflow-y: auto;"
          ></Tree>
        </FormItem>
        <div v-if="menuManagementForm.menuType === 'B'">
          <!-- 按钮名称 -->
          <FormItem :label="$t('MenuManagement.buttonName')" prop="buttonName">
            <Input
              v-model="menuManagementForm.buttonName"
              style="width:300px;"
            ></Input>
          </FormItem>
          <!-- 权限标识 -->
          <FormItem :label="$t('MenuManagement.permissionIcon')" prop="perms">
            <Input
              v-model="menuManagementForm.perms"
              style="width:300px;"
            ></Input>
          </FormItem>
        </div>
        <div v-else>
          <!-- 菜单标题 -->
          <FormItem :label="$t('MenuManagement.menuTitle')" prop="title">
            <Input
              v-model="menuManagementForm.title"
              style="width:300px;"
            ></Input>
          </FormItem>
          <!-- 英文标题 -->
          <FormItem :label="$t('MenuManagement.englishTitle')" prop="titleEnglish">
            <Input
              v-model="menuManagementForm.titleEnglish"
              style="width:300px;"
            ></Input>
          </FormItem>
          <!-- 菜单图标 -->
          <FormItem :label="$t('MenuManagement.menuIcon')" prop="icon">
            <Input
              v-model="menuManagementForm.icon"
              style="width:300px;"
            ></Input>
          </FormItem>
          <!-- 排序 -->
          <FormItem :label="$t('MenuManagement.sort')" prop="order">
            <Input
              v-model="menuManagementForm.order"
              style="width:300px;"
            ></Input>
          </FormItem>
          <!-- 地址栏路径 -->
          <FormItem :label="$t('MenuManagement.addressPath')" prop="path">
            <Input
              v-model="menuManagementForm.path"
              style="width:300px;"
            ></Input>
          </FormItem>
          <!-- 组件路径 -->
          <FormItem :label="$t('MenuManagement.componentPath')" prop="component">
            <Input
              v-model="menuManagementForm.component"
              style="width:300px;"
            ></Input>
          </FormItem>
        </div>
      </Form>
    </Modal>
  </div>
</template>
<script>
import { setCookie, getCookie } from "../../../../utils/cookieUtil.js";
import TableMenuManagement from "../menu_management/TableMenuManagement";
var tableMenuManagement = TableMenuManagement;
export default {
  data() {
    return {
      loading: true,
      menuId: "",
      menuManagementModal: false,
      menuTypeList: [
        {
          id: 0,
          label: "C",
          name: this.$t("MenuManagement.directory")
        },
        {
          id: 1,
          label: "M",
          name: this.$t("MenuManagement.menu")
        },
        {
          id: 2,
          label: "B",
          name: this.$t("MenuManagement.button")
        }
      ],
      menuManagementForm: {
        titleEnglish: "",
        title: "",
        order: "",
        path: "",
        menuType: "C",
        component: "",
        icon: "",
        buttonName: "",
        perms: "",
        menuRole: 0,
        companyIds: ""
      },
      menuRoleList: [
        {
          id: 0,
          label: 0,
          name: this.$t("MenuManagement.normalMenu")
        },
        {
          id: 1,
          label: 1,
          name: this.$t("MenuManagement.paidMenu")
        }
      ],
      companyList: [{ id: "0", name: this.$t("MenuManagement.general") }],
      ruleValidate: {
        companyIds: [
          {
            required: true,
            message: this.$t("alarms.common.pleaseSelectCompany") // trigger: "change", // type: "array"
          }
        ],
        menuType: [
          {
            required: true,
            message: this.$t("MenuManagement.pleaseSelectType"),
            trigger: "change",
            type: "string"
          }
        ],
        title: [{ required: true, message: this.$t("MenuManagement.pleaseInputMenuTitle"), trigger: "blur" }],
        titleEnglish: [
          { required: true, message: this.$t("MenuManagement.pleaseInputEnglishTitle"), trigger: "blur" }
        ],
        order: [{ required: true, message: this.$t("MenuManagement.pleaseInputSort"), trigger: "blur" }],
        path: [
          { required: true, message: this.$t("MenuManagement.pleaseInputAddressPath"), trigger: "blur" }
        ],
        component: [
          { required: true, message: this.$t("MenuManagement.pleaseInputComponentPath"), trigger: "blur" }
        ],
        icon: [{ required: false, message: this.$t("MenuManagement.pleaseInputMenuIcon"), trigger: "blur" }],
        buttonName: [
          { required: true, message: this.$t("MenuManagement.pleaseInputButtonName"), trigger: "blur" }
        ],
        perms: [{ required: true, message: this.$t("MenuManagement.pleaseInputPermissionIcon"), trigger: "blur" }]
      },
      menuData: [],
      selection: []
    };
  },
  mounted() {
    this.getCompanyDropDownBox();
  },
  watch: {
    "menuManagementForm.companyIds"(newVal, oldVal) {
      if (newVal.includes("0")) {
        this.companyList.forEach(item => (item.disabled = true));
        this.companyList[0].disabled = false;
        this.menuManagementForm.companyIds = this.companyList[0].id;
      } else {
        this.companyList.forEach(item => (item.disabled = false));
      }
    }
  },
  methods: {
    // 显示不同图标
    renderContent(h, { root, node, data }) {
      if (data.menuType == "B") {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%"
            }
          },
          [
            h("span", [
              h("Icon", {
                props: {
                  type: "ios-radio-button-on"
                },
                style: {
                  marginRight: "8px"
                }
              }),
              h("span", data.title)
            ])
          ]
        );
      } else if (data.menuType == "C") {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%"
            }
          },
          [
            h("span", [
              h("Icon", {
                props: {
                  type: "ios-bookmark"
                },
                style: {
                  marginRight: "8px"
                }
              }),
              h("span", data.title)
            ])
          ]
        );
      } else if (data.menuType == "M") {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%"
            }
          },
          [
            h("span", [
              h("Icon", {
                props: {
                  type: "ios-grid"
                },
                style: {
                  marginRight: "8px"
                }
              }),
              h("span", data.title)
            ])
          ]
        );
      }
    },
    search: function() {
      if (this.menuManagementForm.companyIds.length == 0) {
        return;
      }
      this.$api.menu
        .menuTreeNode({
          companyId: this.menuManagementForm.companyIds,
          menuType: this.menuManagementForm.menuType
        })
        .then(res => {
          // 所有菜单数组
          this.menuData = res.data;
        });
    },
    // 获取公司下拉框
    getCompanyDropDownBox: function() {
      this.$api.company
        .getCompanyDropDownBox("userName", getCookie(global.cookieName))
        .then(res => {
          this.companyList = this.companyList.concat(res.data);
          this.menuManagementForm.companyIds = this.companyList[0].id;
          this.companyList.forEach(element => {
            element.disabled = false;
          });
        });
    },
    changeCompany() {
      this.search();
    },
    // 切换菜单类型
    changeMenuType: function() {
      this.search();
    },
    selectAll: function(selection) {
      this.menuId = "";
      this.selection = selection;
      for (var i = 0; i < this.selection.length; i++) {
        this.menuId = this.selection[i].menuId;
      }
    },
    menuManagementSubmit: function(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          // 添加
          var menuDTO = {
            menuType: this.menuManagementForm.menuType
          };
          // 目录
          if (this.menuManagementForm.menuType == "C") {
            //如果parentId传给后端为空 后端parentId为0
            menuDTO.parentId = this.menuId;
            menuDTO.title = this.menuManagementForm.title;
            menuDTO.titleEn = this.menuManagementForm.titleEnglish;
            menuDTO.component = this.menuManagementForm.component;
            menuDTO.path = this.menuManagementForm.path;
            menuDTO.order = this.menuManagementForm.order;
            menuDTO.type = this.menuManagementForm.icon;
            menuDTO.menuRole = this.menuManagementForm.menuRole;
            menuDTO.companyIds = this.menuManagementForm.companyIds;
          } else if (this.menuManagementForm.menuType == "M") {
            //如果parentId传给后端为空 后端parentId为0
            menuDTO.parentId = this.menuId;
            menuDTO.title = this.menuManagementForm.title;
            menuDTO.titleEn = this.menuManagementForm.titleEnglish;
            menuDTO.component = this.menuManagementForm.component;
            menuDTO.path = this.menuManagementForm.path;
            menuDTO.order = this.menuManagementForm.order;
            menuDTO.type = this.menuManagementForm.icon;
            menuDTO.menuRole = this.menuManagementForm.menuRole;
            menuDTO.companyIds = this.menuManagementForm.companyIds;
          } else if (this.menuManagementForm.menuType == "B") {
            menuDTO.parentId = this.menuId;
            menuDTO.title = this.menuManagementForm.buttonName;
            menuDTO.perms = this.menuManagementForm.perms;
            menuDTO.menuRole = this.menuManagementForm.menuRole;
            menuDTO.companyIds = this.menuManagementForm.companyIds;
          }
          if (menuDTO.companyIds == 0) {
            menuDTO.companyIds = [0];
          }
          this.$api.menu.menuCreate(menuDTO).then(res => {
            setTimeout(() => {
              tableMenuManagement.methods.showAll();
              this.$refs[name].resetFields();
              this.loading = false;
              this.$nextTick(() => {
                this.loading = true;
              });
              this.$Message.success(this.$t("common.addSuccess"));
              this.menuId = "";
              this.selection = [];
              this.menuManagementModal = false;
              this.menuManagementForm.companyIds = this.companyList[0].id;
            }, 1000);
          });
        } else {
          this.loading = false;
          setTimeout(() => {
            this.loading = true;
          }, 0);
          this.$Message.error(this.$t("common.addFail"));
        }
      });
    },
    menuManagementReset: function(name) {
      this.menuId = "";
      this.selection = [];
      this.$refs[name].resetFields();
      this.menuData = [];
      //   companyIds 重置为 默认第一个
      this.menuManagementForm.companyIds = this.companyList[0].id;
    }
  }
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/configuration/permissions_configuration_management/menu_management/AddMenuManagement.vue